module.exports = __webpack_public_path__ + "static/img/1069_small.ea8aeaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1069_small.png
// module id = ZZoC
// module chunks = 1